export enum FormFieldTypesNames {
  TEXT_INPUT = "Short Text",
  FORM_LINK = "Form link",
  TEXT_AREA = "Long Text",
  MULTIPLE_CHOICES = "Choices",
  DROPDOWN = "Dropdown",
  DATE_INPUT = "Date",
  TIME_PICKER = "Time",
  LINEAR_SCALING = "Slider",
  FILE_UPLOAD = "File Upload",
  CURRENCY = "Currency",
  RATING = "Rating",
  DATE_TIME_PICKER = "Date & Time",
  CHECK_BOX = "Decision Box",
  NAME = "Name",
  ADDRESS = "Address",
  PHONE = "Phone",
  EMAIL = "Email",
  DECIMAL = "Decimal",
  DECISION_BOX = "Decision Box",
  CALCULATIVE = "Formula",
  PAGE_BREAK = "Page Break",
  PAYMENT = "Payment",
  GEOLOCATION = "Geolocation",
  NUMBER_INPUT = "Number",
  WEBSITE = "Website",
  SECTION = "Section",
  PIN_CODE = "Pincode",
  BUTTON = "Button",
  SIGNATURE_BOX = "Signature",
  DOUBLE_PANEL = "DoublePanel",
  BANNER = "Banner",
  LINKED_DROPDOWN="Linked Dropdown"
}

export enum FormFieldTypes {
  TEXT_INPUT = "TEXT_INPUT",
  TEXT_AREA = "TEXT_AREA",
  MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
  NUMBER_INPUT = "NUMBER_INPUT",
  DROPDOWN = "DROPDOWN",
  DATE_INPUT = "DATE_INPUT",
  TIME_PICKER = "TIME_PICKER",
  LINEAR_SCALING = "LINEAR_SCALING",
  FILE_UPLOAD = "FILE_UPLOAD",
  CURRENCY = "CURRENCY",
  RATING = "RATING",
  DATE_TIME_PICKER = "DATE_TIME_PICKER",
  CHECK_BOX = "CHECK_BOX",
  DECIMAL = "DECIMAL",
  DECISION_BOX = "DECISION_BOX",
  CALCULATIVE = "CALCULATIVE",
  PAGE_BREAK = "PAGE_BREAK",
  PAYMENT = "PAYMENT",
  GEOLOCATION = "GEOLOCATION",
  SECTION = "SECTION",
  LOOKUP = "LOOKUP",
  PIN_CODE = "PIN_CODE",
  BUTTON = "Button",
  SIGNATURE_BOX = "SIGNATURE_BOX",
  DOUBLE_PANEL = "DOUBLE_PANEL",
  BANNER = "BANNER",
  LINKED_DROPDOWN="LINKED_DROPDOWN"
}
